import axios from "axios";
import moment from "moment/moment";
import isArray from "lodash-es/isArray";

export const nFormatter = (num, digits) => {
  const lookup = [
    { value: 1, symbol: "" },
    { value: 1e3, symbol: "k" },
    { value: 1e6, symbol: "M" },
    { value: 1e9, symbol: "G" },
    { value: 1e12, symbol: "T" },
    { value: 1e15, symbol: "P" },
    { value: 1e18, symbol: "E" },
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  var item = lookup
    .slice()
    .reverse()
    .find(function (item) {
      return num >= item.value;
    });
  return item
    ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol
    : "0";
};

export const lightenDarkenColor = (col, amt) => {
  var usePound = false;
  if (col[0] == "#") {
    col = col.slice(1);
    usePound = true;
  }

  var num = parseInt(col, 16);

  var r = (num >> 16) + amt;

  if (r > 255) r = 255;
  else if (r < 0) r = 0;

  var b = ((num >> 8) & 0x00ff) + amt;

  if (b > 255) b = 255;
  else if (b < 0) b = 0;

  var g = (num & 0x0000ff) + amt;

  if (g > 255) g = 255;
  else if (g < 0) g = 0;

  return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
};

export const getRandomNumberBetween0To255 = () => {
  return Math.floor(Math.random() * 200);
};

export const colors = [
  "#4DC6C4",
  "#FFBE0B",
  "#702962",
  "#E1A6D7",
  "#CBEDEC",
  "#FCE49F",
  "#AFAAB9",
  "#E75A7C",
  "#7D83FF",
  "#416788",
  "#F5F0F6",
  "#ED254E",
  "#FF99C9",
  "#297045",
  "#BA9593",
  "#335C81",
  "#A2999E",
  "#CE84AD",
  "#EF767A",
  "#857E7B",
  "#EF5D60",
  "#143109",
  "#BA1200",
  "#B58DB6",
  "#E5C1BD",
  "#BA5624",
  "#19535F",
  "#B298DC",
  "#02394A",
  "#DB5461",
  "#FCEFEF",
  "#E4C1F9",
  "#6C757D", // dark gray
];

const getRandomDarkColor = () => {
  const letters = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

export const getColors = (data = []) => {
  return data.map((_c, i) =>
    i <= data.length - 1 && !!colors[i]
      ? colors[i]
      : getRandomDarkColor()
  );
};

export const generateRandom = (min = 10, max = 100) => {
  let difference = max - min;
  let rand = Math.random();
  rand = Math.floor(rand * difference);
  rand = rand + min;
  return rand;
};

export const isMobile = () => {
  var check = false;
  (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\\-(n|u)|c55\/|capi|ccwa|cdm\\-|cell|chtm|cldc|cmd\\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\\-s|devi|dica|dmob|do(c|p)o|ds(12|\\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\\-|_)|g1 u|g560|gene|gf\\-5|g\\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\\-(m|p|t)|hei\\-|hi(pt|ta)|hp( i|ip)|hs\\-c|ht(c(\\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\\-(20|go|ma)|i230|iac( |\\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\\-[a-w])|libw|lynx|m1\\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\\-([1-8]|c))|phil|pire|pl(ay|uc)|p\\-2|po(ck|rt|se)|prox|psio|pt\\-g|qa\\-a|qc(07|12|21|32|60|\\-[2-7]|i\\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\\-|oo|p\\-)|sdk\/|se(c(\\-|0|1)|47|mc|nd|ri)|sgh\\-|shar|sie(\\-|m)|sk\\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\\-|v\\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\\-|tdg\\-|tel(i|m)|tim\\-|t\\-mo|to(pl|sh)|ts(70|m\\-|m3|m5)|tx\\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\\-|your|zeto|zte\\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};

export const isNewCase = (caseData) => {
  if (caseData.caseDate) {
    const cDate = moment(caseData.caseDate, 'YYYY-MM-DD HH:mm');
    const today = moment();
    const last7DayDate = moment().subtract(7, 'days');
    return cDate.isSame(today, 'date') || cDate.isBetween(last7DayDate, today, 'date');
  }
  return false;
};

export const isDateBetween = (dates = [], comparableDate) => {
  // const cDate = moment(comparableDate, 'YYYY-MM-DD');
  const cDate = moment(comparableDate, 'YYYY-MM-DD HH:mm');
  if (!cDate.isValid()) return false;
  if (dates.length == 1) {
    return moment(dates[0]).isSame(moment(cDate), 'date');
  } else {
    let [date1, date2] = dates;
    date1 = moment(date1).subtract(1, 'day');
    date2 = moment(date2).subtract(1, 'day');
    return moment(cDate).isBetween(date1, date2, 'dates');
  }
};

export const getFormatedDate = (date, format, dateFormat, hideNoTime = false) => {
  if (date) {
    let momentDate = undefined;
    if (dateFormat) {
      momentDate = moment(date, dateFormat);
    } else {
      momentDate = moment.utc(String(date).toUpperCase());
    }
    const dformat = hideNoTime ? 'DD MMM YYYY' : format ? format : "DD MMM YYYY HH:mm";
    try {
      if (momentDate.isValid()) {
        return momentDate.format(dformat);
      }
      return "-";
    } catch (error) {
      return "-";
    }
  } else {
    return "-";
  }
};

export const capitalizeFirstLetter = (string) => {
  try {
    if (!string) return '';
    if (isArray(string)) {
      return string.map(s => s.charAt(0).toUpperCase() + s.slice(1)).join(", ");
    }
    return string.charAt(0).toUpperCase() + string.slice(1);
  } catch (error) {
    return '';
  }
};

export const isIsoDate = (str) => {
  if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.[\d{3}|\d{2}]Z/.test(str)) return false;
  const d = new Date(str);
  return d instanceof Date && !isNaN(d.getTime()) && d.toISOString() === str; // valid date 
};

export const getValidDate = (strDate) => {
  const returnFormat = 'YYYY-MM-DD HH:mm';
  let formatedDate = '';
  try {
    if (strDate) {
      if ((strDate.includes('t') || strDate.includes('T')) && (strDate.includes('z') || strDate.includes('Z'))) {
        strDate = (strDate || '').toUpperCase();
        formatedDate = moment.utc(strDate).format(returnFormat);
      } else {
        const [, month] = strDate.split(' ');
        const monthNames = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
        if (monthNames.includes(month)) {
          formatedDate = moment(strDate, 'DD MMMM YYYY').format(returnFormat);
        } else {
          formatedDate = moment(strDate, 'DD MMM YYYY').format(returnFormat);
        }
      }
    }
  } catch (error) {
    formatedDate = '';
  }
  return formatedDate;
};

export const getNumberOnly = (number) => number
  .replace(/[^0-9.-]/g, '')       // remove chars except number, hyphen, point. 
  .replace(/(\..*)\./g, '$1')     // remove multiple points.
  .replace(/(?!^)-/g, '')         // remove middle hyphen.
  .replace(/^0+(\d)/gm, '$1');

export const clearEmpties = (o) => {
  for (var k in o) {
    if (!o[k] || typeof o[k] !== "object") {
      continue
    }

    clearEmpties(o[k]);
    if (Object.keys(o[k]).length === 0) {
      delete o[k];
    }
  }
  return o;
};

export const handleError = (error) => {
  if (axios.isAxiosError(error) && error?.response) {
    if (error?.response?.data && (
      error?.response?.data?.message
      || error?.response?.data?.error
      || error?.response?.data?.error?.reason
      || (error?.response?.data?.error?.caused_by && error?.response?.data?.error?.caused_by?.reason)
      || error?.response?.data?.error?.root_cause)
    ) {
      let errorMessage = '';
      if ((error?.response?.data?.error?.root_cause ?? []).length > 0) {
        errorMessage = (error?.response?.data?.error?.root_cause ?? []).map(r => r.reason).join('\n');
      } else if (error?.response?.data?.error?.reason) {
        errorMessage = error?.response?.data?.error?.reason ?? '';
      } else if (error?.response?.data?.error?.caused_by && error?.response?.data?.error?.caused_by?.reason) {
        errorMessage = error?.response?.data?.error?.caused_by?.reason ?? '';
      } else if (error?.response?.data?.error) {
        errorMessage = String(error?.response?.data?.error ?? '');
      } else if (error?.response?.data?.message) {
        errorMessage = error?.response?.data?.message ?? '';
      }
      return errorMessage;
    } else if (error?.response?.status == 429 && error?.response?.statusText) {
      return error?.response?.statusText ?? '';
    } else {
      return 'Something went wrong. Please load data after sometime.';
    }
  } else {
    return error?.message ?? 'Something went wrong. Please load data after sometime.';
  }
};

export const formatedNumber = (num, format = 'en-GB') => {
  return Number(num).toLocaleString(format);
};

export const stringToArray = (data) => {
  if (isArray(data)) {
    return data;
  }
  return [data];
};